<div class="confirm-dialog-container" data-cy="explanation-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="explanation-header-section">
      <div class="section-header-title" data-cy="explanation-title-text">
        {{ title }}
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="explanation-content-section">
      <div data-cy="explanation-message-text">{{ message }}</div>
      <div data-cy="explanation-input-container">
        <mat-form-field floatLabel='never' style="width:100%" data-cy="explanation-form-field">
          <input matInput width="100%" [placeholder]="'Please explain'"
                 [(ngModel)]="this.explanation"
                 autocomplete="off"
                 data-cy="explanation-reason-input">
        </mat-form-field>
      </div>

    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="explanation-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button *ngIf="isShowCancel" (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="explanation-cancel-button">Cancel</button>
      <button *ngIf="isShowNo" (click)="onNoClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="explanation-no-button">No</button>
      <button (click)="onOkClick()" [disabled]="!this.isTextEntered()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="explanation-ok-button">Ok</button>
    </div>
  </div>
</div>

